<template>
    <div class="generate_step">
        <h3>Generate Website?</h3>
        <p class="margin_bottom">Please confirm that you have <b>completed all details accurately</b> as the final design is dependent on the information provided</p>
        <div class="md-layout generate_icons">
            <div class="md-layout-item">
                <md-icon class="md-size-5x">domain</md-icon>
            </div>
            <div class="md-layout-item">
                <md-icon class="md-size-4x">trending_flat</md-icon>
            </div>
            <div class="md-layout-item">
                <md-icon class="md-size-5x md-success">language</md-icon>
            </div>
        </div>

        <p>If you are not 100% sure the content for <b>{{name}}</b> is fully complete/accurate you can <b v-if="allowSave">Save</b><b v-else>Continue</b> and return to <b>Generate</b>
         later, or <a :href="generateAdviceUrl" class="a_default">Contact us for advice</a></p>
        
        
        
        <h3 class="chb_generate_confirm">Confirmation</h3>
        <p class="warning_note">By providing a PO Number and clicking 'Generate' you confirm that details are complete, accurate and ready for public release on the web</p>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-10 md-form-label">
                P/O
            </label>
            <div class="md-layout-item md-size-70">
                <ValidationProvider ref="validationProviderPoNumber" name="PO Number" rules="required|min:5" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <span class="md-prefix">&sharp;</span>
                        <md-input type="text" v-model="generate.poNumber"></md-input>
                        <span class="md-helper-text">Purchase Order Number (&pound;600 + VAT)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>


         <div class="md-layout md-gutter div_confirm_controls">
            <label class="md-layout-item md-size-10 md-form-label">
                
            </label>
            <div class="md-layout-item md-size-70 pad_top">
                <ValidationProvider ref="validationProviderTermsAndConditions" name="Terms And Conditions" :rules="{ required: { allowFalse: false } }" v-slot="{ passed, failed }">
                    <div class="md_field_like" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-checkbox v-model="generate.termsAccepted" name="Terms And Conditions" type="checkbox">I Accept the </md-checkbox><a :href="termsAndConditionsUrl" class="a_default a_in_chb">Terms and Conditions</a>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </div>
                </ValidationProvider>
            </div>
        </div>

        

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-10 md-form-label">

            </label>
            <div class="md-layout-item" style="padding-left: 15px;">
                <md-button class="md-success" :disabled="!allowGenerate" title="Click to generate the website" @click="$emit('generateWebsite')">Generate</md-button>
                <md-button v-if="allowSave" @click="$emit('save')" class="md-raised md-success" style="margin-left: 3rem;">Save</md-button>
                <md-button v-else @click="$emit('done')" class="md-raised md-success" style="margin-left: 3rem;">Continue</md-button>
            </div>
        </div>

    </div>
</template>

<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);

    import { BuildingStatus } from '@/ts/buildingSpec';

    export default {
        name: 'BuildingGenerate',
        components: {
            SlideYDownTransition
        },
        props: {
            generate: {
                poNumber: null
            },
            name: null,
            status: null,
            id:null
        },
        computed: {
            generateAdviceUrl() {
                var subject = `Generate Advice | ${window.location.href}`;
                return `mailto:tech@unitview.co.uk?subject=${encodeURI(subject)}`;
            },
            termsAndConditionsUrl() {
                //return `${this.$currentConfig.apiBaseUrl}/websites/terms-and-conditions/${this.id}`;
                return `${this.$currentConfig.apiBaseUrl}/websites/${this.id}/terms-and-conditions.pdf`;
            },
            allowGenerate() {
                return this.pOCorrect && this.termsCorrect;
            },
            allowSave() {
                return this.status != BuildingStatus.saved;
            }
        },
        mounted() {
            this.calcValidation();
        },
        methods: {
            calcValidation() {
                this.$refs.validationProviderPoNumber.validate().then(valResult => {
                    this.pOCorrect = (valResult.valid === true);
                });
                this.$refs.validationProviderTermsAndConditions.validate().then(valResult => {
                    this.termsCorrect = (valResult.valid === true);
                });
            }
        },
        data() {
            return {
                pOCorrect: false,
                termsCorrect: false,
            };
        },
        watch: {
            'generate.poNumber'() {
                this.calcValidation();
            },
            'generate.termsAccepted'() {
                this.calcValidation();
            }
        }
    }
</script>

<style lang="scss">
    .md_field_like {
        display: flex;
    }

        .md_field_like .md-checkbox.md-theme-default {
            margin-right:5px;
        }

        .md_field_like .md-icon {
            margin-right: 0;
            font-size: 20px !important;
            line-height: 20px;
            margin-top: -2px;
        }

        .md_field_like.md-valid .md-icon {
            color: #4caf50 !important;
        }
        .md_field_like.md-error .md-icon {
            color: #f44336 !important;
        }

    .a_in_chb {
        height: 20px;
        line-height: 20px;
        font-weight: bold;
    }
</style>
